module.exports = __webpack_public_path__ + "static/img/12.f34b4dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/12.png
// module id = 6wdu
// module chunks = 0